import React, { useState, useEffect, useReducer, useRef } from 'react';
import { Slider, Label, Tooltip } from 'devextreme-react/slider';
import ColorBox from 'devextreme-react/color-box';
import roundPng from '../icons/ellipse.png'
import rectPng from '../icons/rectangle.png'
import linePng from '../icons/line.png'
export default (props) => {
    const { updateTool, updateProps, addTxt, clear, setLnClr, lnClr, save, updateBg, bgColor, updateClrs, fillColor, isRps } = props
    return (<div className="whiteTools" >
        <span title="Select" className="tool-box-spn" onClick={() => updateTool('Select')}><i className="fas fa-mouse-pointer"></i></span>
        <span title="Pencil" className="tool-box-spn" onClick={() => updateTool('Pencil')}><i className="fas fa-pencil-alt"></i></span>
        <span title="Draw Line" onClick={() => updateTool('Line')} className="tool-box-spn" ><b>/</b></span>
        <span title="Draw Circle" onClick={() => updateTool('Circle')}  className="tool-box-spn" ><i className="far fa-circle"></i></span>
        <span title="Draw Rectangle" onClick={() => updateTool('Rectangle')}  className="tool-box-spn" ><i className="far fa-square"></i></span>
        <span title="Insert text" className="tool-box-spn hide" onClick={() => { addTxt('txt') }}><i className="fas fa-font"></i></span>
        <span className="tool-box-spn opty3">  </span>
        <span title="Delete" className="tool-box-spn hide" onClick={() => updateProps('clear')}><i className="fas fa-trash"></i></span>
        <span title="Undo" className="tool-box-spn" onClick={() => updateProps('undo')}><i className="fas fa-undo"></i></span>
        <span title="Redo" className="tool-box-spn" onClick={() => updateProps('redo')}><i className="fas fa-redo"></i></span>
        <span className="tool-box-spn opty3">  </span>
        <span className="tool-box-spn" title="Zoom in" onClick={() => updateProps('zIn')} ><i className="fas fa-search-plus"></i></span>
        <span className="tool-box-spn" title="Zoom out" onClick={() => updateProps('zOut')} ><i className="fas fa-search-minus"></i></span>
        <span className="tool-box-spn opty3">  </span>
        <span title="Clear all" className="tool-box-spn" onClick={() => updateProps('remove')}><i className="fas fa-times"></i></span>
        {!isRps && <span title="Save" className="tool-box-spn" onClick={save}><i className="fas fa-save"></i></span>}
        <span className="tool-box-spn opty3">  </span>
        <div className="dx-field" style={{ "padding": "0px 5px" }}>
            <div className="dx-field-value">
                <div style={{ "width": "28px", "float": "left", paddingRight: "6px" }}>Size: </div> <Slider style={{ "float": "left", marginTop: "-5px" }} min={1} max={100} width="150px" min={2} max={100} defaultValue={4} onValueChanged={val => { updateProps('width', val) }} ><Tooltip enabled={true} position="bottom" /></Slider>
            </div>
        </div>
        <span className="tool-box-spn opty3">  </span>
        <div className="dx-field" style={{ "padding": "0px 5px" }}>
            <div className="dx-field-value">
                <div style={{ "width": "36px", "float": "left", paddingRight: "6px" }}>Line: </div> <ColorBox
                    value={lnClr}
                    onValueChanged={(e) => updateClrs('line', e.value)}
                    style={{ marginTop: "-8px", float: "left", width: '144px' }} />
            </div>
        </div> 
        <div className="dx-field" style={{ "padding": "0px 5px" }}>
            <div className="dx-field-value">
                <div style={{ "width": "26px", "float": "left", paddingRight: "6px" }}>Fill: </div> <ColorBox
                    value={fillColor}
                    onValueChanged={(e) => updateClrs('fill', e.value)}
                    style={{ marginTop: "-8px", float: "left", width: '144px' }} />
            </div>
        </div> 
        </div>);
}
